module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-right-blue-1a1496bf96c24c500731fcc571a4f3bd.svg";